import Header from '../../components/Header';
import Footer from '../../components/Footer';
import produtos from '../../data/produtos.json';
import blogPosts from '../../data/blog-posts.json';
import { useEffect } from 'react';

// JSON-LD Structured Data for Produtos Page
const jsonLdData = {
  "@context": "https://schema.org",
  "@type": "OfferCatalog",
  "name": "Soluções Target Software",
  "url": "https://www.targetsoftware.com.br/produtos",
  "provider": {
    "@type": "Organization",
    "name": "Target Software",
    "url": "https://www.targetsoftware.com.br",
    "logo": "https://www.targetsoftware.com.br/assets/img/logo.png"
  },
  "itemListElement": [
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Target Incentivos",
        "alternateName": "Gestão Completa de Campanhas de Incentivo",
        "url": "https://www.targetsoftware.com.br/produtos/target-incentivos",
        "description": "Solução líder para gestão de campanhas de incentivo e apuração de remuneração variável, sem limitação de usuários e com total flexibilidade para regras de negócio.",
        "serviceType": "Gestão de Campanhas de Incentivo e Remuneração Variável",
        "keywords": [
          "campanhas de incentivo",
          "remuneração variável",
          "comissionamento",
          "incentivos comerciais",
          "gestão comercial"
        ],
        "image": "https://www.targetsoftware.com.br/assets/img/target-incentivos-banner.png"
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Target Partnership",
        "alternateName": "Gestão Inteligente de Parceiros Comerciais",
        "url": "https://www.targetsoftware.com.br/produtos/target-partnership",
        "description": "Plataforma completa para onboarding, gestão, apuração de comissionamento e ciclo de pagamento de parceiros comerciais com transparência e automação.",
        "serviceType": "Gestão de Parceiros Comerciais",
        "keywords": [
          "gestão de parceiros",
          "canais indiretos",
          "comissionamento automático",
          "onboarding digital",
          "software de canais"
        ],
        "image": "https://www.targetsoftware.com.br/assets/img/target-partnership-banner.png"
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Target Sales",
        "alternateName": "Automação e Microgerenciamento Comercial",
        "url": "https://www.targetsoftware.com.br/produtos/target-sales",
        "description": "Solução de automação comercial e gestão operacional com pipeline, alertas inteligentes, IA, planejamento e controle completo de indicadores.",
        "serviceType": "Automação Comercial e Gestão de Pipeline",
        "keywords": [
          "automação comercial",
          "gestão de pipeline",
          "funil de vendas",
          "alertas inteligentes",
          "indicadores comerciais"
        ],
        "image": "https://www.targetsoftware.com.br/assets/img/target-sales-banner.png"
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Inteligência de Dados",
        "alternateName": "Business Intelligence e Data Analytics",
        "url": "https://www.targetsoftware.com.br/produtos/inteligencia-dados",
        "description": "Painéis personalizados de BI com IA, análise preditiva, alertas automáticos, plano de ação e construção de malhas de dados estruturadas.",
        "serviceType": "Business Intelligence, Data Analytics e Data Engineering",
        "keywords": [
          "business intelligence",
          "dashboards personalizados",
          "análise de dados",
          "alertas automáticos",
          "data engineering"
        ],
        "image": "https://www.targetsoftware.com.br/assets/img/inteligencia-dados-banner.png"
      }
    }
  ]
};

const ProdutosPage = () => {
  // Add JSON-LD structured data to head
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLdData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header bannerHeightPercent={0.5} />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-[#161e2d] py-20">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 bg-[#7d2128] rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-40 h-40 bg-[#7d2128] rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 left-1/2 w-48 h-48 bg-blue-600 rounded-full blur-3xl"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium mb-6 text-white">
              <i className="ri-apps-line mr-2"></i>
              Portfólio Completo
            </div>
            <h1 className="font-bold text-white mb-6 leading-tight">
              <span className="text-xl lg:text-2xl block mb-2">Soluções que transformam</span>
              <span className="text-4xl lg:text-6xl text-[#7d2128] block">Estratégia em Resultados</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8">
              Mais de 23 anos desenvolvendo plataformas especializadas para gestão de incentivos,
              parcerias comerciais e inteligência de dados que impulsionam o sucesso empresarial.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center text-gray-400">
              <div className="flex items-center">
                <i className="ri-shield-check-line text-green-400 mr-2 text-xl"></i>
                <span>Soluções Robustas e Escaláveis</span>
              </div>
              <div className="flex items-center">
                <i className="ri-customer-service-line text-green-400 mr-2 text-xl"></i>
                <span>Suporte Dedicado</span>
              </div>
              <div className="flex items-center">
                <i className="ri-award-line text-green-400 mr-2 text-xl"></i>
                <span>Retorno Comprovado</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {produtos.map((produto, index) => (
              <div
                key={produto.id}
                className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  } gap-8 lg:gap-12 items-center`}
              >
                {/* Product Image/Icon Side */}
                <div className="flex-1 w-full">
                  <a href={produto.link} className="block">
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-105">
                      {/* Header com cor escura */}
                      <div className="p-6" style={{ backgroundColor: produto.color }}>
                        <div className="flex items-center">
                          <div className={`w-12 h-12 bg-white rounded-xl flex items-center justify-center mr-4`}>
                            <i className={`${produto.icon} text-2xl`} style={{ color: produto.color }}></i>
                          </div>
                          <h3 className="text-2xl font-bold text-white">{produto.name}</h3>
                        </div>
                      </div>

                      {/* Imagem com filtro de cor */}
                      <div className="relative overflow-hidden" style={{ height: '350px' }}>
                        <div className="absolute inset-0">
                          <img
                            src={`/images/produtos/${produto.slug}.jpg`}
                            alt={produto.name}
                            className="w-full h-full object-cover object-top opacity-80"
                          />
                          <div
                            className="absolute inset-0 bg-gradient-to-r"
                            style={{ background: `linear-gradient(to right, ${produto.color}cc, ${produto.color}99)` }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                {/* Product Info Side */}
                <div className="flex-1 w-full">
                  <div className="space-y-6">
                    <div>
                      <div className="flex flex-wrap gap-2 mb-3">
                        {produto.tags.map((tag, tagIdx) => (
                          <span
                            key={tagIdx}
                            className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium"
                            style={{ backgroundColor: `${produto.color}20`, color: produto.color }}
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                      <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                        {produto.name}
                      </h2>
                      <p className="text-lg text-gray-600 leading-relaxed">
                        {produto.description}
                      </p>
                    </div>

                    {/* Features */}
                    <div>
                      <h3 className="text-sm font-semibold text-gray-900 mb-3 uppercase tracking-wide">
                        Recursos Principais
                      </h3>
                      <div className="grid md:grid-cols-2 gap-3">
                        {produto.features.slice(0, 4).map((feature, idx) => (
                          <div key={idx} className="flex items-center">
                            <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                            <span className="text-gray-700 text-sm">{feature}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Benefits */}
                    <div>
                      <h3 className="text-sm font-semibold text-gray-900 mb-3 uppercase tracking-wide">
                        Benefícios Chave
                      </h3>
                      <div className="grid md:grid-cols-2 gap-3">
                        {produto.benefits.slice(0, 2).map((benefit, idx) => (
                          <div key={idx} className="flex items-center">
                            <i className="ri-star-fill mr-2 flex-shrink-0" style={{ color: produto.color }}></i>
                            <span className="text-gray-700 text-sm font-medium">{benefit}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Insights e Conhecimento</h2>
            <p className="text-xl text-gray-600">Acompanhe as últimas tendências e melhores práticas do mercado</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <article key={post.id} className="group cursor-pointer">
                <a href={`/blog/${post.slug}`} className="block">
                  <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                    <div className="aspect-video overflow-hidden">
                      <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                    </div>
                    <div className="p-6">
                      <div className="flex items-center justify-between mb-3">
                        <span className="text-xs font-medium text-[#7d2128] bg-[#7d2128]/10 px-3 py-1 rounded-full">{post.category}</span>
                        <span className="text-xs text-gray-500">{post.date}</span>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-3 group-hover:text-[#7d2128] transition-colors duration-300">{post.title}</h3>
                      <p className="text-gray-600 text-sm leading-relaxed">{post.description}</p>
                      <div className="mt-4 flex items-center text-[#7d2128] text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        Ler mais
                        <i className="ri-arrow-right-line ml-1"></i>
                      </div>
                    </div>
                  </div>
                </a>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Por que Escolher a <span className="text-[#7d2128]">Target Software</span>?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Números que comprovam nossa excelência e compromisso com resultados
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-[#7d2128] to-[#9d2832] rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-4xl text-white"></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">23 anos</div>
              <div className="text-gray-600">Experiência de mercado <br /> comprovada</div>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-4xl text-white"></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">+150</div>
              <div className="text-gray-600">Projetos implantados <br /> em mais de 40 clientes</div>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-green-600 to-green-700 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-line text-4xl text-white"></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">+100.000</div>
              <div className="text-gray-600">Pessoas e empresas <br />apuradas mensalmente</div>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-purple-600 to-purple-700 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-4xl text-white"></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">3 meses</div>
              <div className="text-gray-600">Implantação rápida <br />integrada ao seu ambiente</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-[#161e2d]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Pronto para transformar seus resultados?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Descubra como nossas soluções podem impulsionar seu negócio
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contato"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-[#161e2d] font-semibold rounded-xl hover:bg-white transition-all duration-200 hover:scale-105"
            >
              <i className="ri-mail-send-line text-xl mr-3"></i>
              Fale com um Especialista
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProdutosPage;
